import { DEFAULT_BRANDING } from "@/types/ui/branding";
import { Agent } from "./activityResourceUtils";

export interface BrandingData {
  brandColor: string;
  secondaryColor: string;
  logoUrl: string | undefined;
  hasGradient: boolean;
  gradientAngle: number;
  hasBranding: boolean;
  backgroundGradient: string;
}

/**
 * Extract branding data from agent
 */
export function extractBrandingData(agent: Agent | null): BrandingData {
  if (!agent) {
    return {
      brandColor: DEFAULT_BRANDING.primaryColor,
      secondaryColor: DEFAULT_BRANDING.primaryColor,
      logoUrl: undefined,
      hasGradient: true,
      gradientAngle: 135,
      hasBranding: false,
      backgroundGradient: DEFAULT_BRANDING.primaryColor,
    };
  }

  const brandColor =
    agent.branding?.primaryColor || agent.brand_color || DEFAULT_BRANDING.primaryColor;
  const secondaryColor = agent.branding?.secondaryColor || brandColor;
  const logoUrl =
    agent.branding?.logoUrl || agent.branding?.customAvatarUrl;
  const hasGradient = agent.branding?.gradientEnabled !== false;
  const gradientAngle = agent.branding?.gradientAngle || 135;
  const hasBranding = !!(agent.branding || agent.brand_color);
  const backgroundGradient =
    hasGradient && hasBranding
      ? `linear-gradient(${gradientAngle}deg, ${brandColor}, ${secondaryColor})`
      : brandColor;

  return {
    brandColor,
    secondaryColor,
    logoUrl,
    hasGradient,
    gradientAngle,
    hasBranding,
    backgroundGradient,
  };
}
